import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable()
export class ErrorService {

  private errorAnnouncedSource = new Subject<string>();
  errorAnnouncedSource$ = this.errorAnnouncedSource.asObservable();

  announceError(message: string) {
    this.errorAnnouncedSource.next(message);
  }
}
